import { Component, OnInit, Input } from '@angular/core';
import { Partner } from '@fitscovery/partner/data-access'; 

@Component({
  selector: 'fitscovery-ui-default-section-last',
  templateUrl: './ui-default-section-last.component.html',
  styleUrls: ['./ui-default-section-last.component.scss']
})
export class UiDefaultSectionLastComponent implements OnInit {
  @Input() partner: Partner;
  @Input() isRound: boolean;
  @Input() isSmall: boolean;

  constructor() { }

  ngOnInit(): void {
    this.isRound = !this.isRound
    ? false
    : this.isRound;
  this.isSmall = !this.isSmall
    ? false
    : this.isSmall;
  }

}
